/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
/* eslint-disable max-len */

import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { FC, PropsWithChildren } from 'react';

type ModalProps = {
    isOpen: boolean;
    onClose: () => void;
    title: string;
};

export const Modal: FC<PropsWithChildren<ModalProps>> = ({ isOpen, onClose, children, title }) => {
    return (
        <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50" />
                <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg max-w-[80%] max-h-[80vh] flex flex-col z-50 border">
                    <div className="flex items-center p-4 pb-0">
                        <Dialog.Title className="text-lg font-semibold">{title}</Dialog.Title>
                        <Dialog.Close asChild>
                            <button onClick={onClose} className="ml-auto">
                                <X size={20} />
                            </button>
                        </Dialog.Close>
                    </div>
                    <div className="p-4 overflow-y-auto overflow-x-hidden">{children}</div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
